<section class="component-page">
  @if (router.url === '/assets') {
    <app-introduction-box
      [title]="'asset.overview.title'"
      [description]="'asset.overview.introductionText'"
      [hidable]="true"
      [imageSrc]="'assets/images/asset-introduction-box.png'"
      [imageAlt]="'asset-introduction-box image'"
    >
      <ng-template let-hidden>
        <app-button
          [label]="'asset.overview.button.create' | transloco"
          [matIcon]="'add'"
          [iconPosition]="'end'"
          (click)="goToCreateAssetPage()"
          (keydown.enter)="$event.stopPropagation()"
          (keyup.space)="$event.stopPropagation()"
        ></app-button>
      </ng-template>
    </app-introduction-box>
  }

  <router-outlet></router-outlet>
</section>
